import * as React from 'react';

interface IUseEmptyListingShowTrackingParams {
  offersLength: number;
  isActive: boolean;
  onTrack(): void;
}

export function useEmptyListingShowTracking({
  offersLength,
  isActive,
  onTrack,
}: IUseEmptyListingShowTrackingParams): () => void {
  const firedRef = React.useRef(false);

  React.useEffect(() => {
    if (firedRef.current && offersLength > 0) {
      firedRef.current = false;
    }
  }, [offersLength]);

  return React.useCallback(() => {
    if (!firedRef.current && isActive) {
      onTrack();
      firedRef.current = true;
    }
  }, [isActive, onTrack]);
}
